import { Config } from '../config';
import { Permission, Policy } from '../interfaces';
import { HttpService } from './http.service';

export interface TestPolicyTarget {
  user_id?: string;
  group_name?: string;
}

export interface TestPolicyScope {
  fleet_uuid?: string;
}

export interface TestPolicyRequest {
  target: TestPolicyTarget;
  scope?: TestPolicyScope;
}

export interface TestPolicyResponse {
  permissions: string[];
  applied_policies?: Array<{
    id: string;
    description?: string;
    effect: string;
  }>;
}

const path = `${Config.API}/api/v1/access_policies`;

export abstract class PolicyService {
  public static getAllPolicies = (): Promise<Policy[]> => {
    return HttpService.fetchAuthorized(`${path}`).then((res) => {
      return res || [];
    });
  };

  public static getAllPermissions = (): Promise<Permission[]> => {
    return HttpService.fetchAuthorized(`${path}/permissions`).then((res) => {
      return res?.sort((a: Permission, b: Permission) => a.resource.localeCompare(b.resource)) || [];
    });
  };

  public static testPolicy = (body: TestPolicyRequest): Promise<TestPolicyResponse> => {
    return HttpService.fetchAuthorized(
      `${path}/test`,
      {
        method: 'POST',
        body: JSON.stringify(body),
      },
      undefined,
      true,
    ).then(
      (res) => Promise.resolve(res),
      (rej) => Promise.reject(rej),
    );
  };
}
